import React from 'react';

export default function PrestamosActivosFilters({ 
  filters, 
  onChange, 
  onApply, 
  onReset, 
  loading, 
  errors = {}, 
  formError = '',
  asesores = []
}) {
  const getErrorMessage = (error) => {
    if (!error) return '';
    return Array.isArray(error) ? error[0] : error;
  };

  const fieldClass = (hasError) =>
    `w-full rounded-2xl border bg-white px-4 py-3 text-sm text-gray-900 shadow-sm transition
     ${hasError 
       ? 'border-red-400 ring-2 ring-red-200 focus:ring-red-300 focus:border-red-400'
       : 'border-gray-200 focus:ring-2 focus:ring-red-200 focus:border-red-300'}`;

  return (
    <section className="space-y-4">
      {/* Error del formulario */}
      {!!formError && (
        <div 
          className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-red-700 text-sm" 
          role="alert" 
          aria-live="polite"
        >
          {formError}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-start">
        {/* BÚSQUEDA */}
        <div>
          <label 
            htmlFor="search" 
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            BUSCAR CLIENTE
          </label>
          <input
            id="search"
            name="search"
            type="text"
            placeholder="Nombre, apellido o DNI..."
            value={filters.search}
            onChange={onChange}
            className={fieldClass(!!errors.search)}
            aria-invalid={!!errors.search}
            aria-describedby={errors.search ? 'search_error' : undefined}
          />
          <div className="h-5">
            {!!errors.search && (
              <p id="search_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.search)}
              </p>
            )}
          </div>
        </div>

        {/* ASESOR */}
        <div>
          <label 
            htmlFor="asesor_id" 
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            ASESOR
          </label>
          <select
            id="asesor_id"
            name="asesor_id"
            value={filters.asesor_id || ''}
            onChange={onChange}
            className={fieldClass(!!errors.asesor_id)}
            aria-invalid={!!errors.asesor_id}
            aria-describedby={errors.asesor_id ? 'asesor_id_error' : undefined}
          >
            <option value="">Todos los asesores</option>
            {asesores.map(asesor => (
              <option key={asesor.id} value={asesor.id}>
                {asesor.nombre}
              </option>
            ))}
          </select>
          <div className="h-5">
            {!!errors.asesor_id && (
              <p id="asesor_id_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.asesor_id)}
              </p>
            )}
          </div>
        </div>

        {/* ABONADO POR */}
        <div>
          <label
            htmlFor="abonado_por"
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            ABONADO POR
          </label>
          <select
            id="abonado_por"
            name="abonado_por"
            value={filters.abonado_por || ''}
            onChange={onChange}
            className={fieldClass(!!errors.abonado_por)}
            aria-invalid={!!errors.abonado_por}
            aria-describedby={errors.abonado_por ? 'abonado_por_error' : undefined}
          >
            <option value="">TODOS</option>
            <option value="CUENTA CORRIENTE">CUENTA CORRIENTE</option>
            <option value="CAJA CHICA">CAJA CHICA</option>
          </select>
          <div className="h-5">
            {!!errors.abonado_por && (
              <p id="abonado_por_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.abonado_por)}
              </p>
            )}
          </div>
        </div>

        {/* CASI POR TERMINAR */}
        <div>
          <label className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2">
            FILTROS ADICIONALES
          </label>
          <div className="flex items-center h-[48px] px-3 border border-gray-200 rounded-2xl bg-gray-50">
            <input
              id="casi_por_terminar"
              name="casi_por_terminar"
              type="checkbox"
              checked={filters.casi_por_terminar || false}
              onChange={(e) => onChange({ 
                target: { 
                  name: 'casi_por_terminar', 
                  value: e.target.checked 
                } 
              })}
              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
            />
            <label 
              htmlFor="casi_por_terminar" 
              className="ml-2 text-sm text-gray-700 cursor-pointer"
            >
              Casi por terminar (1-2 cuotas)
            </label>
          </div>
          <div className="h-5"></div>
        </div>

        {/* Acciones */}
        <div className="flex flex-col sm:flex-row gap-3 md:col-span-2 lg:col-span-4">
          <button
            type="button"
            onClick={onApply}
            disabled={loading}
            aria-busy={loading}
            className="w-full sm:flex-1 rounded-full bg-red-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 hover:shadow-md disabled:cursor-not-allowed disabled:bg-gray-300"
          >
            {loading ? 'Cargando…' : 'Aplicar'}
          </button>

          <button
            type="button"
            onClick={onReset}
            disabled={loading}
            className="w-full sm:flex-1 rounded-full border border-red-200 bg-white px-6 py-3 text-sm font-semibold text-red-600 shadow-sm transition hover:border-red-300 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-70"
          >
            Limpiar
          </button>
        </div>
      </div>
    </section>
  );
}